export enum InvoiceStatus {
  NEW = "new",
  PREPROCESSED = "unreviewed",
  REVIEWED = "reviewed",
  EXPORTING = "exporting",
  EXPORTED = "exported",
  ERROR = "error",
  EXPORT_FAILED = "export_failed",
}

export enum InvoiceProcessingStatus {
  UPLOADED = "UPLOADED",
  FILE_PROCESSED = "FILE_PROCESSED",
  EXTRACTED = "EXTRACTED",
  TAGGED = "TAGGED",
  SUPPLIER_MATCHING = "SUPPLIER_MATCHING",
  SUPPLIER_MATCHED = "SUPPLIER_MATCHED",
  ACCOUNT_SELCTED = "ACCOUNT_SELCTED",
  VAT_SELECTED = "VAT_SELECTED",
  CONFIDENCE_CALCULATED = "CONFIDENCE_CALCULATED",
}

export enum InvoiceSmbReviewStatus {
  UNREVIEWED = "unreviewed",
  REVIEWED = "reviewed",
  REVIEWED_ZERO_TOUCH = "reviewed_zero_touch",
}

export const InvoiceProcessingLoadingSteps = [
  [InvoiceProcessingStatus.UPLOADED, InvoiceProcessingStatus.FILE_PROCESSED],
  [
    InvoiceProcessingStatus.EXTRACTED,
    InvoiceProcessingStatus.TAGGED,
    InvoiceProcessingStatus.SUPPLIER_MATCHING,
    InvoiceProcessingStatus.SUPPLIER_MATCHED,
  ],
  [
    InvoiceProcessingStatus.VAT_SELECTED,
    InvoiceProcessingStatus.ACCOUNT_SELCTED,
    InvoiceProcessingStatus.CONFIDENCE_CALCULATED,
  ],
];

export const InvoiceProcessingSteps = {
  IS_REVIEWED: [
    InvoiceStatus.REVIEWED,
    InvoiceStatus.EXPORTING,
    InvoiceStatus.EXPORTED,
    InvoiceStatus.EXPORT_FAILED,
  ],
};

export enum InvoiceType {
  PAYABLE = "payable",
  RECEIVABLE = "receivable",
}
